import { render, staticRenderFns } from "./RechargePage.vue?vue&type=template&id=545b7cab&scoped=true"
import script from "./RechargePage.vue?vue&type=script&lang=js"
export * from "./RechargePage.vue?vue&type=script&lang=js"
import style0 from "./RechargePage.vue?vue&type=style&index=0&id=545b7cab&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b7cab",
  null
  
)

export default component.exports